import React from "react";
import { Tooltip, IconButton, TextField, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon } from "@icarius-icons";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';

const gridStyle = { height: 75, padding: "0px 10px" };

const RatingDetail = (props) => {

  const {
    inUse,
    index,
    data,
    deleteItem,
    modifyItem,
    formData,
    targetList
  } = props;

  return (
    <>
      <div style={{ width: "100%" }}>
        <DialogTitleDivider />
      </div>
      <Grid container item xs={12} direction="row" style={{ paddingTop: 10, position: 'relative', paddingRight: !inUse ? 40 : 0 }}>
        <Grid container alignItems="center" style={{ position: 'relative' }}>
          <Grid container item alignItems="center" xs={12} md={3} style={gridStyle}>
            <TextField
              disabled={inUse}
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("ratingName")}
              value={data.name}
              onChange={(e) => modifyItem(index, e.target.value, 'name')}
              inputProps={{ maxLength: 60 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} md={3} style={gridStyle}>
            <TextField
              disabled={inUse}
              fullWidth
              required
              margin={"none"}
              label={getLocalizedString("numericRatingValue")}
              InputProps={{ inputComponent: CustomNumberFormat }}
              value={data.value}
              onChange={(e) => modifyItem(index, e.target.value, 'value')}
              inputProps={{ min: "0.1", step: "0.1", decimals: 1, fixedDecimalScale: false }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-target-${index}`}>{getLocalizedString("targetRatingScales")}</InputLabel>
              <Select
                value={data.target}
                labelId={`label-target-${index}`}
                id={`select-target-${index}`}
                onChange={(e) => modifyItem(index, e.target.value, "target")}
                margin={"none"}
              >
                {
                  targetList?.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          {
            !inUse && <div style={{ position: 'absolute', right: -40, width: 40, top: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Tooltip title={getLocalizedString("delete")}>
                <IconButton size={"small"} disableRipple onClick={() => deleteItem(index)}>
                  <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          }
        </Grid>
        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
          <TextFieldMultiline
            fullWidth
            label={getLocalizedString("ratingCriteria")}
            required={formData.type === "C"}
            rows={5}
            margin={"none"}
            value={data.criterion}
            onChange={(e) => modifyItem(index, e.target.value, "criterion")}
            inputProps={{ spellCheck: 'false' }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default RatingDetail;